export default {"src":"/_next/static/media/dropEndsIn.86c55416.svg","height":205,"width":318};